/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
export const NEXT_LINE_OFFSET = 10;
